import { Injectable } from "@angular/core";

import { AppService } from "../app.service";
import { BaseInjectorService } from "../base/base-service.injector";

@Injectable({
    providedIn: 'root'
  })
export class CurrentTourResolverService extends BaseInjectorService  {
    constructor(private appService: AppService) {
        super();
    }

    async resolve() {
        if (!this.appService.currentTour) {
            const currentTour = await this.lhStorage.get('currentTour');
            if (currentTour) {
                this.appService.currentTour = currentTour
                return Promise.resolve(currentTour);
            } else {
                this.appService.currentTour = {};
                this.lhStorage.set('currentTour', {});
                return Promise.resolve(currentTour);
            }
        } else {
            this.appService.currentTour = await this.lhStorage.get('currentTour');
            return Promise.resolve(this.appService.currentTour);
        }
    }
}